let commonLocalisations = {
  en: {
    login: {
      title: 'Study Registration',
      subtitle: 'Please log in with your Migraine Buddy account',
      email: 'Migraine Buddy Email',
      password: 'Migraine Buddy Password',
      downloadInstructionTitle: 'Don\'t have a Migraine Buddy account?',
      downloadInstructionBody:
        `1. Download Migraine Buddy on <a style="color: white; text-decoration: underline;" href="https://play.google.com/store/apps/details?id=com.healint.migraineapp&referrer=utm_source=squarestudy" target="_blank">Android</a> or <a style="color: white; text-decoration: underline;" href="https://itunes.apple.com/app/apple-store/id975074413" target="_blank">iOS</a>
        <br>
        2. Create an account with your email`
    },
    generic: {
      agree: 'I agree',
      disagree: 'I disagree',
      confirm: 'Confirm',
      back: 'Back',
      next: 'Next',
      or: 'or',
      gender: 'Gender',
      male: 'Male',
      female: 'Female',
      confirmation: 'Please check that the information is correct.',
      doNotRefresh: 'To log out, please refresh the page.'
    },
    consent: {
      withdrawConsent: 'Withdraw Consent'
    },
    error: {
      genericMessage: `Sorry! It seems like something has gone wrong. Please contact <a href="mailto:jenny@healint.com" class="primary-color"><u>jenny@healint.com</u></a> or try again later.`,
      invalidEmail: 'Please enter a valid email',
      emptyPassword: 'Please key in your Migraine Buddy password',
      invalidCredentials: 'This combination of email and password is not valid. If you\'ve forgotten your password, please reset your password on your Migraine Buddy app.',
      emptyStudyIdentifier: `<p>Please key in your study identifier.</p>`,
      invalidStudyIdentifier: `<p>Please check that format of your study identifier is correct.</p>`,
      emptyStudyGender: `<p>Please state your gender.</p>`
    }
  },
  fr: {
    login: {
      title: 'Inscription à l\'étude',
      subtitle: 'Veuillez vous connecter avec votre compte Migraine Buddy',
      email: 'Migraine Buddy Email',
      password: 'Migraine Buddy mot de passe',
      downloadInstructionTitle: 'Vous n\'avez pas de compte Migraine Buddy?',
      downloadInstructionBody:
        `1. Téléchargez Migraine Buddy sur <a style="color: white; text-decoration: underline;" href="https://play.google.com/store/apps/details?id=com.healint.migraineapp&referrer=utm_source=squarestudy" target="_blank">Android</a> ou <a style="color: white; text-decoration: underline;" href="https://itunes.apple.com/app/apple-store/id975074413" target="_blank">iOS</a>
      <br>
      2. Créez un compte avec votre email`
    },
    generic: {
      agree: 'Je suis d\'accord',
      disagree: 'Je ne suis pas d\'accord',
      confirm: 'Confirmer',
      back: 'Retour',
      next: 'Suvant',
      or: 'ou',
      gender: 'La sexe',
      male: 'Mâle',
      female: 'Femelle',
      confirmation: 'S\'il vous plaît vérifier que les informations sont correctes.',
      doNotRefresh: 'Pour vous déconnecter, veuillez actualiser la page.'
    },
    consent: {
      withdrawConsent: 'Retirer son consentement'
    },
    error: {
      genericMessage: `Pardon! Il semble que quelque chose a mal tourné. Veuillez contacter <a href="mailto:jenny@healint.com" class="primary-color"><u>jenny@healint.com</u></a> ou réessayer plus tard.`,
      invalidEmail: 'S\'il vous plaît entrer un email valide.',
      emptyPassword: 'Veuillez entrer votre mot de passe Migraine Buddy.',
      invalidCredentials: 'Cette combinaison d\'adresse électronique et de mot de passe n\'est pas valide. Si vous avez oublié votre mot de passe, réinitialisez-le sur votre application Migraine Buddy.\n.',
      emptyStudyIdentifier: `<p>Veuillez saisir votre numéro de patient.</p>`,
      invalidStudyIdentifier: `<p>Veuillez vérifier que le format de votre numéro de patient est correct.</p>`,
      emptyStudyGender: `<p>S'il vous plaît indiquer votre sexe.</p>`
    }
  },
  de: {
    login: {
      title: 'Study-Registrierung',
      subtitle: 'Bitte loggen Sie sich mit Ihrem Migraine Buddy-Konto ein',
      email: 'Migraine Buddy E-Mail',
      password: 'Migraine Buddy Passwort',
      downloadInstructionTitle: 'Sie haben kein Migraine-Buddy-Konto?',
      downloadInstructionBody:
        `1. Laden Sie Migraine Buddy für <a style="color: white; text-decoration: underline;" href="https://play.google.com/store/apps/details?id=com.healint.migraineapp&referrer=utm_source=squarestudy" target="_blank">Android</a> oder <a style="color: white; text-decoration: underline;" href="https://itunes.apple.com/app/apple-store/id975074413" target="_blank">iOS</a> herunter
        <br>
        2. Erstellen Sie ein Konto mit Ihrer E-Mail`
    },
    generic: {
      agree: 'Stimme zu',
      disagree: 'Nein',
      confirm: 'Bestätigen',
      back: 'Zurück',
      next: 'Nächster',
      or: 'oder',
      gender: 'Geschlecht',
      male: 'Männlich',
      female: 'Weiblich',
      confirmation: 'Bitte überprüfen Sie, ob die Informationen korrekt sind.',
      doNotRefresh: 'Um sich abzumelden, aktualisieren Sie bitte die Seite.'
    },
    consent: {
      withdrawConsent: 'Einwilligung widerrufen'
    },
    error: {
      genericMessage: `Leider ist ein Fehler aufgetreten. Versuchen Sie es erneut oder schicken Sie eine E-Mail an <a href="mailto:jenny@healint.com" class="primary-color"><u>jenny@healint.com</u></a>, falls Sie Hilfe brauchen.`,
      invalidEmail: 'Bitte geben Sie eine gültige Email-Adresse ein.',
      emptyPassword: 'Bitte geben Sie Ihr Migraine Buddy Passwort ein.',
      invalidCredentials: 'Diese Kombination aus E-Mail und Passwort ist nicht gültig. Wenn Sie Ihr Passwort vergessen haben, setzen Sie Ihr Passwort in Ihrer Migraine Buddy App zurück.',
      emptyStudyIdentifier: `<p>Bitte geben Sie Ihre Studienkennung ein.</p>`,
      invalidStudyIdentifier: `<p>Bitte überprüfen Sie, ob das Format Ihres Studienbezeichners korrekt ist.</p>`,
      emptyStudyGender: `<p>Bitte geben Sie Ihr Geschlecht an.</p>`
    }
  },
  it: {
    login: {
      title: 'Registrazione dello studio',
      subtitle: 'Effettua il login con il tuo account di Migraine Buddy',
      email: 'Email di Migraine Buddy',
      password: 'Migraine Buddy password',
      downloadInstructionTitle: 'Non hai un account di Migraine Buddy?',
      downloadInstructionBody:
        `1. Scarica Migraine Buddy su <a style="color: white; text-decoration: underline;" href="https://play.google.com/store/apps/details?id=com.healint.migraineapp&referrer=utm_source=squarestudy" target="_blank">Android</a> o <a style="color: white; text-decoration: underline;" href="https://itunes.apple.com/app/apple-store/id975074413" target="_blank">iOS</a>
        <br>
        2. Crea un account con la tua email`
    },
    generic: {
      agree: 'Sono d\'accordo',
      disagree: 'Non sono d\'accordo',
      confirm: 'Confermare',
      back: 'Indietro',
      next: 'Il prossimo',
      or: 'o',
      gender: 'Genere',
      male: 'Maschio',
      female: 'Femmina',
      confirmation: 'Si prega di verificare che le informazioni siano corrette.',
      doNotRefresh: 'Per disconnettersi, si prega di aggiornare la pagina.'
    },
    consent: {
      withdrawConsent: 'Ritirare il consenso'
    },
    error: {
      genericMessage: `Scusate! Sembra che qualcosa sia andato storto. Si prega di contattare <a href="mailto:jenny@healint.com" class="primary-color"><u>jenny@healint.com</u></a> o riprovare più tardi.`,
      invalidEmail: 'Inserisci una email valida',
      emptyPassword: 'Please key in your Migraine Buddy password',
      invalidCredentials: 'Per favore inserisci la tua password di Migraine Buddy.',
      emptyStudyIdentifier: `<p>Per favore inserisci il tuo numero di paziente.</p>`,
      invalidStudyIdentifier: `<p>Si prega di verificare che il formato del proprio numero di paziente sia corretto.</p>`,
      emptyStudyGender: `<p>Per favore indica il tuo sesso.</p>`
    }
  },
  es: {
    login: {
      title: 'Inscripción en el estudio',
      subtitle: 'Inicie sesión con su cuenta de Migraine Buddy',
      email: 'Correo electrónico de Migraine Buddy ',
      password: 'Contraseña de Migraine Buddy ',
      downloadInstructionTitle: '¿No tiene una cuenta de Migraine Buddy?',
      downloadInstructionBody:
        `1. Descargar Migraine Buddy en <a style="color: white; text-decoration: underline;" href="https://play.google.com/store/apps/details?id=com.healint.migraineapp&referrer=utm_source=squarestudy" target="_blank">Android</a> o <a style="color: white; text-decoration: underline;" href="https://itunes.apple.com/app/apple-store/id975074413" target="_blank">iOS</a>
        <br>
        2. Crear una cuenta con su correo electrónico`
    },
    generic: {
      agree: 'Estoy de acuerdo',
      disagree: 'No estoy de acuerdo',
      confirm: 'Confirmar',
      back: 'Atrás',
      next: 'Siguiente',
      or: 'o',
      gender: 'Sexo',
      male: 'Masculino',
      female: 'Femenino',
      confirmation: 'Por favor verifique que la información es correcta.',
      doNotRefresh: 'Para cerrar sesión, actualice la página.'
    },
    consent: {
      withdrawConsent: 'Retirar el consentimiento'
    },
    error: {
      genericMessage: `Lo siento, parece que algo ha salido mal. Por favor, póngase en contacto con <a href="mailto:jenny@healint.com" class="primary-color"><u>jenny@healint.com</u></a> o inténtelo de nuevo más tarde.`,
      invalidEmail: 'Por favor introduzca una dirección de correo electrónico válida',
      emptyPassword: 'Por favor introduzca una contraseña de Migraine Buddy válida',
      invalidCredentials: 'Los datos del correo electrónico o de la contrasela no son válidos. Si ha olvidado sus datos de inicio de sesión, restablezca su contraseña con Migraine Buddy.',
      emptyStudyIdentifier: `<p>Por favor introduzca su numero de identificación del estudio.</p>`,
      invalidStudyIdentifier: `<p>Por favor, compruebe que su numero de identificación del estudio es correcto.</p>`,
      emptyStudyGender: `<p>Por favor, introduzca su sexo./p>`
    }
  }
}

export default commonLocalisations
